import React from 'react';
import { DynamicIcon } from '../../../components/DynamicIcon';

const checklistIcons = {
  'opening-check': 'FiLogIn',
  'closing-check': 'FiLogOut',
  'temperature-check': 'FiThermometer',
  'cleaning-check': 'FiDroplet',
  'equipment-check': 'FiTool',
  'delivery-check': 'FiTruck',
  'fire-safety-check': 'FiAlertTriangle',
  'allergen-check': 'FiShield',
  'staff-training-check': 'FiUsers',
  'pat-check': 'FiZap',
};

export default function ChecklistIcon({ checklist, className }) {
  return <DynamicIcon iconName={checklist.icon} fallbackIconName={checklistIcons[checklist.slug]} className={className} />;
}
